import { NavLink, useNavigate } from "react-router-dom";
import { ROUTES } from "../Routes";
import { Ornament } from "./Ornament";
import { resetConsent } from "./CookieBanner";
import { Language } from "../constants";
import { useA11y, useStrings } from "../i18n";

interface FooterProps {
  lang: Language;
}

export function Footer({ lang }: FooterProps) {
  const Strings = useStrings(lang);
  const navigate = useNavigate();
  const A11y = useA11y(lang);

  const linkClass = ({ isActive }: { isActive: boolean }) => {
    const baseClasses = "transition-all duration-200 inline-block py-1.5";

    if (isActive) {
      return `${baseClasses} text-stone-900 font-semibold underline decoration-1 underline-offset-4 cursor-default`;
    }

    return `${baseClasses} text-stone-600 hover:text-stone-700 active:scale-95 cursor-pointer`;
  };

  return (
    <footer className="px-6 py-4 flex flex-col items-center gap-4">
      <Ornament width={140} />
      <nav
        aria-label={A11y.footerNav}
        className="grid grid-cols-[1fr_auto_1fr] items-start gap-x-3 text-xs w-full"
      >
        <div className="min-w-0 text-right">
          <NavLink to={ROUTES.ABOUT} className={linkClass}>{Strings.about}</NavLink>
          <span className="text-stone-600 ml-1.5" aria-hidden="true">·</span>
        </div>
        <div className="whitespace-nowrap text-center">
          <NavLink to={ROUTES.TERMS} className={linkClass}>{Strings.terms}</NavLink>
        </div>
        <div className="min-w-0 text-left">
          <span className="text-stone-600 mr-1.5" aria-hidden="true">·</span>
          <NavLink to={ROUTES.CREDITS} className={linkClass}>{Strings.credits}</NavLink>
        </div>
      </nav>
      <button
        onClick={() => {
          resetConsent();
          navigate(ROUTES.HOME);
        }}
        className="-mt-3 text-xs text-stone-600 hover:text-stone-700 cursor-pointer"
      >
        {Strings.cookieSettings}
      </button>
    </footer>
  );
}
